import React from "react";
import data from "./TablesData.json";
import { Table, Badge } from "antd";
// import { DownOutlined } from "@ant-design/icons";
// import "antd/es/date-picker/style/css"; // for css
// import "antd/es/date-picker/style";
// import "antd/dist/antd.css";
import { CardBody, Card, CardHeader } from "reactstrap";

import { Route, Switch } from "react-router-dom";
// import Dashboard from "../../Dashboard/Dashboard";
import { useSelector } from "react-redux";
import LayoutTest from "../../Containers/DefaultLayout/0_Layout";
import BodyLayout from "../../Containers/DefaultLayout/0_Body";

// var badgeProd;
// var badgeFact;

// const productIndex = data.parentTable.row.map(function(product) {
//   return product.prod_index;
// });

// console.log(productIndex);
// const badgeProd = (productIndex1) => {
//   if (productIndex1 === "stable") {
//     return <Badge color="success" />;
//   } else {
//     return <Badge color="danger" />;
//   }
// };
// const factoryIndex = data.parentTable.row.map(function(fact) {
//   return fact.fact_index;
// });
// console.log(factoryIndex);
// if (factoryIndex === "stable") {
//   badgeFact = <p>hello</p>;
// } else {
//   badgeFact = <Badge color="danger" />;
// }

function FactsTable() {
  const lang_choiced = useSelector((state) => state.lang_change);

  // const dispatch = useDispatch();

  // const [prod_status, setProd_status] = useState([
  //   data.parentTable.row.map((func) => func.prod_index),
  // ]);
  // const [fact_status, setFact_status] = useState(
  //   data.parentTable.row.map((func) => func.fact_index)
  // );
  // const [status, setStatus] = useState(null);

  var JSONdata = data.parentTable;
  var data_count = JSONdata.row.length;
  var Badge_color_prod = "";
  var Badge_color_fact = "";
  const rowsource = [];
  for (var i = 0; i < data_count; i++) {
    if (JSONdata.row[i].prod_index === "stable") {
      Badge_color_prod = "green";
    } else {
      Badge_color_prod = "red";
    }
    if (JSONdata.row[i].fact_index === "stable") {
      Badge_color_fact = "green";
    } else {
      Badge_color_fact = "red";
    }
    rowsource.push({
      key: i.toString(),
      // test: this.setState(),

      factName: JSONdata.row[i].fact_name,
      factAddres: JSONdata.row[i].fact_address,
      prodIndex: <Badge color={Badge_color_prod} />,
      factIndex: <Badge color={Badge_color_fact} />,

      // data.parentTable.row[0].prod_index
    });
  }

  data_count = JSONdata.column.length;
  const columnsource = [];
  for (var i = 0; i < data_count; i++) {
    if (i <= 1) {
      columnsource.push({
        title: lang_choiced.components.tablePage.column[i].title,
        dataIndex: lang_choiced.components.tablePage.column[i].dataIndex,
        key: lang_choiced.components.tablePage.column[i].key,
      });
    } else {
      columnsource.push({
        title: lang_choiced.components.tablePage.column[i].title,
        dataIndex: lang_choiced.components.tablePage.column[i].dataIndex,
        key: lang_choiced.components.tablePage.column[i].key,
        filters: [
          { text: "آماده", value: "stable" },
          { text: "غیر آماده", value: "unstable" },
        ],
        filterMultiple: false,
        summary: lang_choiced.components.tablePage.column[i].dataIndex,
        // onFilter: (value, record) => record.summary.indexOf(value) === 0
      });
    }
  }
  //Child table start
  var data_count = JSONdata.row.length;

  const expandedRowRender = () => {
    var JSONdata = data.childTable;
    data_count = JSONdata.column.length;
    const columnsource = [];
    for (var i = 0; i < data_count; i++) {
      if (i <= 1) {
        columnsource.push({
          title: lang_choiced.components.tablePage.column[i].title,
          dataIndex: lang_choiced.components.tablePage.column[i].dataIndex,
          key: lang_choiced.components.tablePage.column[i].key,
        });
      } else {
        columnsource.push({
          title: lang_choiced.components.tablePage.column[i].title,
          dataIndex: lang_choiced.components.tablePage.column[i].dataIndex,
          key: lang_choiced.components.tablePage.column[i].key,
          filters: [
            { text: "آماده", value: "stable" },
            { text: "غیر آماده", value: "unstable" },
          ],
          filterMultiple: false,
          summary: lang_choiced.components.tablePage.column[i].dataIndex,
          // onFilter: (value, record) => record.summary.indexOf(value) === 0
        });
      }
    }

    var Badge_color_prod = "";
    var Badge_color_fact = "";
    const rowsource = [];
    for (var i = 0; i < data_count; i++) {
      if (JSONdata.row[i].prod_index === "stable") {
        Badge_color_prod = "green";
      } else {
        Badge_color_prod = "red";
      }
      if (JSONdata.row[i].fact_index === "stable") {
        Badge_color_fact = "green";
      } else {
        Badge_color_fact = "red";
      }
      rowsource.push({
        key: i.toString(),
        // test: this.setState(),

        factName: JSONdata.row[i].fact_name,
        factAddres: JSONdata.row[i].fact_address,
        prodIndex: <Badge color={Badge_color_prod} />,
        factIndex: <Badge color={Badge_color_fact} />,

        // data.parentTable.row[0].prod_index
      });
    }
    return (
      <Table columns={columnsource} dataSource={rowsource} pagination={false} />
    );
  };
  //child table end
  function onChange(pagination, filters, sorter, extra) {
    // console.log("params", pagination, filters, sorter, extra);
  }

  return (
    <BodyLayout>
      <Card>
        <CardHeader>{lang_choiced.components.tablePage.table_title}</CardHeader>
        <CardBody>
          <Table
            dataSource={rowsource}
            columns={columnsource}
            expandable={{ expandedRowRender }}
            onChange={onChange}
            pagination={{ pageSize: 5 }}
            onRow={(record, rowIndex) => {
              return {
                onClick: () => {}, // click row
              };
            }}
          />
          {/* <Badge status="success" /> */}
        </CardBody>
      </Card>
    </BodyLayout>
  );
}
export default FactsTable;

// const menu = (
//   <Menu>
//     <Menu.Item>Action 1</Menu.Item>
//     <Menu.Item>Action 2</Menu.Item>
//   </Menu>
// );

// render() {
//   const expandedRowRender = () => {
//     // Data
//     var i;
//     const columns = [
//       { title: "Date", dataIndex: "date", key: "date" },
//       { title: "Name", dataIndex: "name", key: "name" },
//       {
//         title: "Status",
//         filters: [{ text: "Finished", value: "Finished" },{ text: "Unfinished", value: "Unfinished" }],
//         key: "state",
//         render: () => (
//           <span>
//             <Badge status="success" />
//             Finished
//           </span>
//         )
//       },
//       { title: "Upgrade Status", dataIndex: "upgradeNum", key: "upgradeNum" },
//       {
//         title: "Action",
//         dataIndex: "operation",
//         key: "operation",
//         render: () => (
//           <span className="table-operation">
//             <a>Pause</a>
//             <a>Stop</a>
//             <Dropdown overlay={menu}>
//               <a>
//                 More <DownOutlined />
//               </a>
//             </Dropdown>
//           </span>
//         )
//       }
//     ];
//     const data = [
//       {
//         key: i,
//         date: "2014-12-24 23:12:00",
//         name: "This is production name",
//         upgradeNum: "Upgraded: 56"
//       }
//     ];

//     //
//     return (
//       <Table
//         style={{ direction: "rtl" }}
//         columns={columns}
//         dataSource={data}
//         pagination={false}
//       />
//     );
//   };

//   const columns = [
//     { title: "Name", dataIndex: "name", key: "name", sorter: true },
//     { title: "Platform", dataIndex: "platform", key: "platform" },
//     { title: "Version", dataIndex: "version", key: "version" },
//     { title: "Upgraded", dataIndex: "upgradeNum", key: "upgradeNum" },
//     { title: "Creator", dataIndex: "creator", key: "creator" },
//     { title: "Date", dataIndex: "createdAt", key: "createdAt" },
//     { title: "Action", key: "operation", render: () => <a>Publish</a> }
//   ];

//   const data = [];
//   for (let i = 0; i < 3; ++i) {
//     data.push({
//       key: i,
//       name: "Screem",
//       platform: "iOS",
//       version: "10.3.4.5654",
//       upgradeNum: 500,
//       creator: "Jack",
//       createdAt: "2014-12-24 23:12:00"
//     });
//   }

//   return (
//     <Table
//       className="components-table-demo-nested"
//       columns={columns}
//       expandable={{ expandedRowRender }}
//       dataSource={data}
//       pagination={true}
//     />
//   );
// }
